import {InfluencerSso, PaginatedInfluencerSso} from '@app/modules/shared/models';

export interface IInfluencerSsoState {
  setting: InfluencerSso;
  settings: InfluencerSso[];
  paginatedInfluencerSso: PaginatedInfluencerSso;
  success: string;
  error: string;
}

export const initialInfluencerSsoState: IInfluencerSsoState = {
  setting: null,
  settings: [],
  paginatedInfluencerSso: null,
  success: '',
  error: ''
};
